<template>
  <div>
    <div @click="showModal = true" class="calender">
      <img src="@/assets/images/calender.svg" alt />
    </div>
    <v-dialog v-model="showModal" persistent scrollable max-width="360px">
      <v-card>
        <v-card-title>
          <h3>表示する案件の期間を選択してください</h3>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-checkbox
            :key="bp.id"
            v-for="bp in sortedItems"
            v-model="selected"
            :value="bp.id"
            hide-details
            messages="none"
          >
            <template v-slot:label>
              <AppPeriod :start="bp.startTime" :end="bp.endTime" />
            </template>
          </v-checkbox>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="onClickCloseButton">
            閉じる
          </v-btn>
          <v-btn @click.native="onClickSaveButton" color="primary">
            変更する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'ChangeBPDialog',
  props: {
    data: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      selected: this.value || this.data.insertionOrderBudgetIds,
    }
  },
  computed: {
    sortedItems() {
      return _sortBy(this.items, 'startTime')
    },
    hasReport() {
      return (
        this.data.insertionOrderBudget ||
        this.data.clicks ||
        this.data.cpc ||
        this.cpm ||
        this.ctr ||
        this.imps ||
        this.revenueBuyingCurrency
      )
    },
    items() {
      return this.data.billingPeriods.filter(bp =>
        dayjs().isAfter(dayjs(bp.startTime).endOf('minute')),
      )
    },
  },
  watch: {
    value() {
      this.selected = this.value || this.data.insertionOrderBudgetIds
    },
  },
  methods: {
    onClickSaveButton() {
      this.showModal = false
      this.$emit('input', this.selected)
    },
    onClickCloseButton() {
      this.showModal = false
      this.selected = this.value
    },
  },
}
</script>
<style scoped lang="scss">
.calender {
  width: 60px;
  margin: 0 auto;
  border-radius: 5px;
  /*padding: 10px 0;*/
  display: flex;
  justify-content: center;
}
.v-input {
  margin-top: 0;
}

.v-messages {
  display: none;
}
</style>
